import React, { Fragment, useEffect, useState } from "react"
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom"
import { useUser } from "./context/UserProvider"
import { getCurrentUser } from "./services/auth.service"
import Inicio from "./pages/Inicio"
import Votaciones from "./pages/User/Votaciones"
import MisVotaciones from "./pages/User/MisVotaciones"
import ClaveUnica from "./ClaveUnica"
import VotaUsuario from "./pages/User/VotaUsuario"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import InicioTricel from "./pages/Tricel/InicioTricel"
import Resultados from "./pages/Tricel/Resultados"
import Padron from "./pages/Tricel/Padron"
import AdminVotacion from "./pages/admin/AdminVotacion"
import AdminUnidades from "./pages/admin/AdminUnidades"
import AdminUsuarios from "./pages/admin/AdminUsuarios"
import { library } from "@fortawesome/fontawesome-svg-core"
import { faEdit, faTrash, faPlus, faUserMinus } from "@fortawesome/free-solid-svg-icons"


toast.configure()
function App() {
	const { setUser } = useUser()
	const [loader, setLoader] = useState(false)
	library.add(faTrash, faEdit, faPlus, faUserMinus)
	
	const setUserIfExists = async () => {
		if (localStorage.getItem("ssid")) {
			setLoader(true)
			const res = await getCurrentUser()
			if (res) {
				await setUser(res)
			} else {
				localStorage.clear()
				toast.warning("La sesión ha expirado")
			}
			setLoader(false)
		}
	}

	useEffect(() => {
		setUserIfExists()
	}, [])

	return (
		<Router>
			<Switch>
				<Route exact path="/">
					<Fragment>
						<Inicio loadingUser={loader} />
					</Fragment>
				</Route>

				<ProtectedRouteUser exact path="/votaciones">
					<Votaciones />
				</ProtectedRouteUser>

				<ProtectedRouteUser exact path="/votausuario">
					<VotaUsuario />
				</ProtectedRouteUser>

				<ProtectedRouteUser exact path="/registro">
					<MisVotaciones />
				</ProtectedRouteUser>

				<ProtectedRouteUser exact path="/tricel">
					<InicioTricel />
				</ProtectedRouteUser>

				<ProtectedRouteUser exact path="/resultados">
					<Resultados />
				</ProtectedRouteUser>

				<ProtectedRouteUser exact path="/padron">
					<Padron />
				</ProtectedRouteUser>

				<ProtectedRouteUser exact path="/admin/votacion">
					<AdminVotacion />
				</ProtectedRouteUser>

				<ProtectedRouteUser exact path="/admin/unidades">
					<AdminUnidades />
				</ProtectedRouteUser>

				<ProtectedRouteUser exact path="/admin/usuarios">
					<AdminUsuarios />
				</ProtectedRouteUser>

				<Route exact path="/claveunica">
					<ClaveUnica />
				</Route>
			</Switch>
			<ToastContainer position="bottom-right" hideProgressBar={true} />
		</Router>
	)
}

const ProtectedRouteUser = ({ children, ...rest }) => {
	const { user } = useUser()

	if (user) {
		return <Route {...rest}>{children}</Route>
	} else {
		return <Redirect to={{ pathname: "/" }} />
	}
}

export default App
